import * as React from 'react';

import {OnboardingModal as OnboardingModalShell} from 'shells/onboarding-modal/onboarding-modal';

import {getArt} from './helpers';
import {BeforeYouConnect} from './pages/before-you-connect';
import {Connect} from './pages/connect';
import {Connected} from './pages/connected';
import {Introduction} from './pages/introduction';
import {SyncConfirmation} from './pages/sync-confirmation';

type Props = {
    isConnected: boolean;
    isEnabled: boolean;
    whatsappPhoneNumber: string | null | undefined;
    onClose: () => void;
    connectIntegration: () => void;
    enableIntegration: () => void;
    disableIntegration: () => void;
    errorMessage?: string | null | undefined;
    setErrorMessage: (errorMessage: string) => void;
    pageAutoAdvance: boolean;
    initiateSync: (shouldSyncContacts: boolean, shouldSyncMessages: boolean) => void;
    isLoadingConnection: boolean;
};

export function OnboardingModal(props: Props) {
    const [shouldSyncContacts, setShouldSyncContacts] = React.useState(true);
    const [shouldSyncMessages, setShouldSyncMessages] = React.useState(true);

    const pages = [
        {
            id: 'Introduction',
            body: <Introduction />,
            art: getArt('Introduction'),
        },
        {
            id: 'BeforeYouConnect',
            body: <BeforeYouConnect />,
            art: getArt('BeforeYouConnect'),
        },
        {
            id: 'Connect',
            body: (
                <Connect
                    isConnected={props.isConnected}
                    connectIntegration={props.connectIntegration}
                    isLoadingConnection={props.isLoadingConnection}
                    errorMessage={props.errorMessage}
                    hideErrorMessage={() => props.setErrorMessage('')}
                />
            ),
            art: getArt('Connect'),
            nextDisabled: !props.isConnected,
        },
        {
            id: 'Connected',
            body: (
                <Connected
                    isEnabled={props.isEnabled}
                    enableIntegration={props.enableIntegration}
                    disableIntegration={props.disableIntegration}
                    whatsappPhoneNumber={props.whatsappPhoneNumber}
                    shouldSyncContacts={shouldSyncContacts}
                    shouldSyncMessages={shouldSyncMessages}
                    setShouldSyncContacts={setShouldSyncContacts}
                    setShouldSyncMessages={setShouldSyncMessages}
                />
            ),
            art: getArt('Connected'),
            nextDisabled: !props.isConnected || (!shouldSyncContacts && !shouldSyncMessages),
            onClickSecondaryButton: props.onClose,
            secondaryButtonText: 'Not now',
            onClickNextButton: () => props.initiateSync(shouldSyncContacts, shouldSyncMessages),
            nextButtonText: 'Sync with WhatsApp',
            stepBackwardsDisabled: true,
        },
        {
            id: 'SyncConfirmation',
            body: (
                <SyncConfirmation
                    shouldSyncContacts={shouldSyncContacts}
                    shouldSyncMessages={shouldSyncMessages}
                />
            ),
            art: getArt('SyncConfirmation'),
            secondaryButtonDisabled: true,
        },
    ];

    return (
        <OnboardingModalShell
            trapFocus={false}
            lastButtonText='Done'
            pages={pages}
            onClose={props.onClose}
            onFinish={props.onClose}
            pageAutoAdvance={props.pageAutoAdvance}
            maxHeight={600}
            closeButton={false}
        />
    );
}
